import { applyDefaultSubProducts, dereffItems } from "./basketHelpers";

export const getCustomItem = (item, customId, basketItems, baseSelections, isDuoRomana) => {
    if (customId) {
        const basketItem = basketItems.find(el => el.customID === customId);
        if (basketItem) {
            return (dereffItems(basketItem));
        }
    }
    else if (item) {
        const baseSelectionOverride = baseSelections.find(b => b.product === item.id);
        if (baseSelectionOverride) {
            item.subProducts[0].defaultSubProduct = baseSelectionOverride.base;
        }

        const defaultItem = applyDefaultSubProducts(item, isDuoRomana);
        const dereffedItem = dereffItems(defaultItem);

        return ({ ...dereffedItem, customID: customId });
    }
}